import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { authGuard } from './auth/auth.guard';
import { DivisionLandingComponent } from './features/division-landing/division-landing.component';
import { ReportsHubComponent } from './features/reports-hub/reports-hub.component';
import { ReportViewerComponent } from './features/reports/report-viewer/report-viewer.component';
import { TreasuryComponent } from './features/treasury/treasury.component';
import { TreasuryRatesComponent } from './features/treasury/treasury-rates.component';
import { StaticValuesComponent } from './features/static-values/static-values.component';
import { ApprovalDashboardComponent } from './features/approvals/approval-dashboard/approval-dashboard.component';

const routes: Routes = [
  {
    path: '',
    component: DivisionLandingComponent,
    canActivate: [authGuard],
    title: 'Bordereau — Select a division'
  },
  {
    path: 'treasury',
    component: TreasuryComponent,
    canActivate: [authGuard],
    title: 'Load Treasury rates'
  },
  {
    path: 'treasury-rates',
    component: TreasuryRatesComponent,
    canActivate: [authGuard],
    title: 'US Treasury rates'
  },
  {
    path: 'static-values',
    component: StaticValuesComponent,
    canActivate: [authGuard],
    title: 'Static - Input Values'
  },
  {
    path: 'approvals',
    component: ApprovalDashboardComponent,
    canActivate: [authGuard],
    title: 'Approval Dashboard'
  },
  {
    path: 'actuary',
    component: ReportsHubComponent,
    canActivate: [authGuard],
    data: { division: 'Actuary' },
    title: 'Actuary reports'
  },
  {
    path: 'actuary/:reportKey',
    component: ReportViewerComponent,
    canActivate: [authGuard],
    data: { division: 'Actuary' }
  },
  {
    path: 'finance',
    component: ReportsHubComponent,
    canActivate: [authGuard],
    data: { division: 'Finance' },
    title: 'Finance reports'
  },
  {
    path: 'finance/:reportKey',
    component: ReportViewerComponent,
    canActivate: [authGuard],
    data: { division: 'Finance' }
  },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
